import {FlowStateController} from "@nolimit/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimit/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimit/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FireInTheHole2} from "../../FireInTheHole2";
import {ScatterCounter} from "../../view/ScatterCounter";

export class FITH2AvalancheIdlePresentation implements FlowStatePresentation {
    constructor() {}

    start(flowStateController:FlowStateController):void {
        SlotGame.apiPlugin.betHandler.zeroBet();
        if (FireInTheHole2.model.isRestore) {
            ScatterCounter.onRestore();
        }
        flowStateController.finish();
    }
}